module.exports = __webpack_public_path__ + "img/cloud_bottom.e70f6787.png";